import { ReactNode } from 'react';

export function UsageSummaryHeaderCell({
  label,
  description
}: {
  label: string | ReactNode;
  description?: string | ReactNode;
}) {
  return (
    <div className='text-default text-left'>
      <div className='text-body-2 text-secondary'>{label}</div>
      {description ? <div className='mt-1 text-body-3'>{description}</div> : null}
    </div>
  );
}
